import { render, staticRenderFns } from "./DDialog.vue?vue&type=template&id=e11c8222&scoped=true"
import script from "./DDialog.vue?vue&type=script&lang=js"
export * from "./DDialog.vue?vue&type=script&lang=js"
import style0 from "./DDialog.vue?vue&type=style&index=0&id=e11c8222&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e11c8222",
  null
  
)

export default component.exports